import React from 'react';
import { Panel, PanelHeader, Group, Div, Progress, InfoRow, HeaderButton, Link, platform, IOS, Footer, Button, List, Cell, Avatar } from '@vkontakte/vkui';
import '@vkontakte/vkui/dist/vkui.css';
import Icon28ChevronBack from '@vkontakte/icons/dist/28/chevron_back';
import Icon24Back from '@vkontakte/icons/dist/24/back';
import * as VKConnect from '@vkontakte/vkui-connect';

import Icon24Done from '@vkontakte/icons/dist/24/done';
import Icon24Error from '@vkontakte/icons/dist/24/error';
import Icon24Cancel from '@vkontakte/icons/dist/24/cancel';

var osname  = platform();
var ad_gid   = 39599132;

function getdesc(count) {
  return String(count).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ') +
  ' ' +
   declOfNum(count, ['подписчик', 'подписчика', 'подписчиков']);
}

function getpoints(count) {
  return String(count).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ') +
  ' ' +
   declOfNum(String(count).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 '), ['балл', 'балла', 'баллов']);
}

function declOfNum(number, titles) {  
    let cases = [2, 0, 1, 1, 1, 2];  
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];  
}

class Result extends React.Component {


  joinGroup(group_id) {
    VKConnect.send("VKWebAppJoinGroup", {
      "group_id": group_id
    });
  }

  shareResult(point) {
    let mesage = `Cообщество @club${this.props.targetGid.id}(${this.props.targetGid.name}) набрало ${getpoints(point)} в SMM Анализаторе!

Ссылка на сервис: https://vk.com/app6671467`;
    VKConnect.send("VKWebAppShowWallPostBox", {
      "message": mesage,
      "attachments": "photo-39599132_456244757"
    });
  }

  componentWillMount() {
    let result_item =  Number(localStorage.getItem('result_item'));
    let iter_go = result_item+1;

    if (this.props.AdGroupInfo.is_member === 0) {
          if (iter_go === 3) {
            setTimeout(
                function() {
                    this.joinGroup(ad_gid);
                }
                .bind(this),
                3000
            );
          }   

        let remainder = iter_go % 10;
        if (remainder === 0){
          setTimeout(
              function() {
                  this.joinGroup(ad_gid);
              }
              .bind(this),
              3000
          );
        }
    }

    result_item = Number(result_item) + 1;
    localStorage.setItem('result_item', result_item);
  }

  render() {

    if (Object.keys(this.props.result.data).length === this.props.result.finished()) {
      
      //выполнилось до конца, записываем статистику на сервер
      this.props.SetSend(this.props.targetGid.id, this.props.fetchedUser.id, this.props.result.point())

      return (
        <Panel id={this.props.id}>

          {osname === IOS ? 
            <PanelHeader noShadow left={<HeaderButton onClick={() => this.props.SetActivePanel('moreGid')} > <Icon28ChevronBack />  </HeaderButton>}>
              Результат
            </PanelHeader>
           : 
            <PanelHeader  left={<HeaderButton onClick={() => this.props.SetActivePanel('moreGid')} > <Icon24Back /> </HeaderButton>}>
              Результат
            </PanelHeader>
          }

          <Group title="Результаты анализа">
            <Div className="mt0">
              {this.props.result.point() >= 90 ? `У сообщества «${this.props.targetGid.name}» ${this.props.result.point()} из 100 возможных баллов! Это отличный  результат.` : null}
              {this.props.result.point() >= 70 && this.props.result.point() <= 89 ? `У сообщества «${this.props.targetGid.name}» ${this.props.result.point()} из 100 возможных баллов! Это хороший результат.` : null}
              {this.props.result.point() >= 50 && this.props.result.point() <= 69 ? `У сообщества «${this.props.targetGid.name}» ${this.props.result.point()} из 100 возможных баллов! Это удовлетворительный результат.` : null}
              {this.props.result.point() <= 49 ? `У сообщества «${this.props.targetGid.name}» ${this.props.result.point()} из 100 возможных баллов! Сообщество требует серьезных доработок.` : null}
            </Div>
          </Group>

        {this.props.AdGroupInfo.is_member === 0 ? // если не подписан на сообщество.
          <Group title="Больше советов в сообществе">
              <List>  
                <Cell 
                key={this.props.AdGroupInfo.id} 
                size="l" 
                before={<Avatar src={this.props.AdGroupInfo.photo_200}/>} 
                description={getdesc(this.props.AdGroupInfo.members_count)}
                bottomContent={
                    <div style={{ display: 'flex' }}>
                      <Button onClick={() => this.joinGroup(ad_gid)}>Подписаться</Button>
                    </div>
                  }>
                  {`${this.props.AdGroupInfo.name}`}
                </Cell>
              </List>
          </Group>
          :null
        }


            {Object.keys(this.props.result.data).map(obj => { // рендерим все поля и выводим текст.

                            switch (this.props.result.data[obj].val) {
                              case true:
                                return <Group title={<span><Icon24Done className="GroupTitle true"/>{this.props.result.data[obj].name}</span>}>
                                          <Div className="mt0">
                                            {this.props.result.data[obj].text_yes.split('\n').map((item, key) => {
                                              return <span key={key}>{item}<br/></span>
                                            })}
                                          </Div>
                                        </Group>
                              
                              case false:
                                return <Group title={<span><Icon24Cancel className="GroupTitle false"/>{this.props.result.data[obj].name}</span>}>
                                          <Div className="mt0">
                                            {this.props.result.data[obj].text_no.split('\n').map((item, key) => {
                                              return <span key={key}>{item}<br/></span>
                                            })}
                                          </Div>
                                        </Group>
                              case 'low': 
                                return <Group title={<span><Icon24Cancel className="GroupTitle low"/>{this.props.result.data[obj].name}</span>}>
                                          <Div className="mt0">
                                            {this.props.result.data[obj].text_low.split('\n').map((item, key) => {
                                              return <span key={key}>{item}<br/></span>
                                            })}
                                          </Div>
                                       </Group>
                              case 'average':
                                return <Group title={<span><Icon24Error className="GroupTitle average"/>{this.props.result.data[obj].name}</span>}>
                                          <Div className="mt0">
                                            {this.props.result.data[obj].text_average.split('\n').map((item, key) => {
                                              return <span key={key}>{item}<br/></span>
                                            })}
                                          </Div>
                                       </Group>
                              case 'normal':
                                return  <Group title={<span><Icon24Done className="GroupTitle normal"/>{this.props.result.data[obj].name}</span>}>
                                          <Div className="mt0">
                                            {this.props.result.data[obj].text_normal.split('\n').map((item, key) => {
                                              return <span key={key}>{item}<br/></span>
                                            })}
                                          </Div>
                                        </Group>
                              case 'good':
                                return <Group title={<span><Icon24Done className="GroupTitle good"/>{this.props.result.data[obj].name}</span>}>
                                          <Div className="mt0">
                                            {this.props.result.data[obj].text_good.split('\n').map((item, key) => {
                                              return <span key={key}>{item}<br/></span>
                                            })}
                                          </Div>
                                       </Group>
                              case 'great':
                                return <Group title={<span><Icon24Done className="GroupTitle great"/>{this.props.result.data[obj].name}</span>}>
                                          <Div className="mt0">
                                            {this.props.result.data[obj].text_great.split('\n').map((item, key) => {
                                              return <span key={key}>{item}<br/></span>
                                            })}
                                          </Div>
                                       </Group>
                              default: return false;
                            }

            })}


      <Group title={<span>Полезные ссылки</span>}>
        <Div className="mt0">
        {
          /*
            <a className="mt0" target="_blank" rel="noopener noreferrer" href="https://vk.com/@cerebro_vk-kurs-ot-cerebrotarget">
              <img className="CustomImgTraining" alt="Обучение SMM" src="https://smm-yugova.ru/img/training-1.png"/>
            </a>
          */
        }
        <a className="mt0" target="_blank" rel="noopener noreferrer" href="https://vk.com/@cerebro_vk-aktivnosti-i-prodazhi-opyt-cerebro-target">
          <img className="CustomImgTraining" alt="Обучение SMM" src="https://sun9-10.userapi.com/c857624/v857624712/855b5/clqK9VjTRwY.jpg"/>
        </a>
       
       </Div>
        <List>
      {/* https://vk.com/video-39599132_456239073 */} 
          <Cell target="_blank" href="https://vk.com/@cerebro_vk-aktivnosti-i-prodazhi-opyt-cerebro-target" before={<Avatar type="app" src="https://smm-yugova.ru/img/stati.png" />} description="Активности и продажи">Обучение от Церебро</Cell>
          <Cell target="_blank" href="https://vk.com/video-39599132_456239125" before={<Avatar type="app" src="https://smm-yugova.ru/img/vovlechenie-statya.png" />} description="Запись стрима">Вовлечение читателей в активности</Cell>
          <Cell onClick={() => this.props.sendTemplatePhoto()} before={<Avatar type="app" src="https://smm-yugova.ru/img/shablon.png" />} description="Файл PSD">Шаблон обложки для фотошопа</Cell>
        </List>
      </Group>

      {
        this.props.AdGroupInfo.is_member === 0 ? // если не подписан на сообщество.
          <Group title={<span>Лайфхак</span>}>
           <Div className="mt0">
              Подпишитесь на сообщество SMM секреты с Анастасией Юговой, чтобы продажи из группы ВКонтакте росли, как на дрожжах.
           </Div>
          <Div className="mt0"> 
            <Button 
                className="mt12" 
                size="xl"
                onClick={() => this.joinGroup(ad_gid)}
            >
                  Подписаться на SMM секреты
            </Button>
          </Div>
          </Group>
        : null
      }

          <Footer>
            <Link target="_blank" className="CustomLink" href="https://vk.com/club39599132">Группа</Link>
            <Link target="_blank" className="CustomLink" href="https://vk.com/@kupiapp-servis-smm-analiz">О приложении</Link>
          </Footer>
        </Panel>
      ) 
    } else {
      return (
        <Panel id={this.props.id}>
          {osname === IOS ? 
            <PanelHeader noShadow left={<HeaderButton onClick={() => this.props.SetActivePanel('moreGid')} > <Icon28ChevronBack />  </HeaderButton>}>
              Идёт анализ
            </PanelHeader>
           : 
            <PanelHeader  left={<HeaderButton onClick={() => this.props.SetActivePanel('moreGid')} > <Icon24Back /> </HeaderButton>}>
              Идёт анализ
            </PanelHeader>
          }
          <Group>
            <Div>
              <InfoRow title="Подождите немного">
                <Progress value={`${this.props.result.getpercent(this.props.result.finished())}`} />
              </InfoRow>
            </Div>
          </Group>
        </Panel>
      ) 
    }
  }
}

export default Result;


// WEBPACK FOOTER //
// ./src/panels/Result.js